import { render, staticRenderFns } from "./Venues.vue?vue&type=template&id=1f189140&"
import script from "./Venues.vue?vue&type=script&lang=ts&"
export * from "./Venues.vue?vue&type=script&lang=ts&"
import style0 from "./Venues.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports